// Import images
import maWLC from './WLCdeptLogo.png';
import baFrEng from './HumanitiesSealWhite.png';

// Map certification names to images
const eduMap = {
  "maWLC": maWLC,
  "baFrEng": baFrEng,
};

// Export both the map and a default
export { eduMap };